import { c as r, d as o } from "../../../index-34b1f277.js";
const { defineMultiStyleConfig: e, definePartsStyle: t } = r(["button"]), n = o({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "flex-start",
  marginY: 1,
  paddingX: "4",
  gap: 1,
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: "primary.100",
  borderRadius: "full",
  backgroundColor: "white",
  transitionProperty: "common",
  transitionDuration: "normal",
  color: "primary.700",
  fontSize: "lg",
  textSelection: "none",
  _disabled: { opacity: 0.5, cursor: "not-allowed" },
  _hover: {
    borderColor: "primary.300",
    outlineColor: "primary.50",
    outlineWidth: 4,
    outlineStyle: "solid"
  },
  _focusVisible: {
    borderColor: "primary.300",
    outlineColor: "primary.50",
    outlineWidth: 4,
    outlineStyle: "solid"
  },
  _expanded: {
    borderColor: "secondary.500",
    outlineWidth: 4,
    outlineStyle: "solid",
    outlineColor: "secondary.50"
  },
  _active: {
    borderColor: "secondary.500",
    outlineColor: "secondary.50"
  },
  "&[data-animation='true']": {
    pointerEvents: "none"
  }
}), i = o({
  fontWeight: "medium",
  span: {
    marginRight: 1,
    color: "primary.300"
  }
}), l = o({
  overflowY: "auto",
  marginTop: 1,
  maxHeight: 234
}), a = o({
  height: "auto",
  padding: 2,
  alignItems: "center",
  justifyContent: "flex-start",
  fontWeight: "normal",
  _active: {
    backgroundColor: "transparent",
    fontWeight: "medium"
  },
  span: {
    marginTop: "2px"
  }
}), d = o({
  color: "primary.300"
}), s = o({
  marginRight: -2
}), u = o({
  display: "inline-flex",
  width: "100%",
  justifyContent: "flex-end"
}), b = t({
  button: n,
  buttonPrefix: i,
  content: l,
  option: a,
  placeholder: d,
  clearButtonContainer: u,
  iconButton: s
}), p = e({
  baseStyle: b,
  variants: {
    borderless: {
      button: {
        fontWeight: 500,
        border: "none",
        background: "transparent",
        _hover: {
          border: "none",
          backgroundColor: "primary.50",
          outlineColor: "transparent"
        },
        _focusVisible: {
          borderColor: "none",
          outlineColor: "primary.50",
          outlineWidth: 4,
          outlineStyle: "solid"
        },
        _expanded: {
          border: "none",
          backgroundColor: "primary.100",
          outlineColor: "transparent"
        },
        _active: {
          border: "none",
          backgroundColor: "primary.100",
          outlineColor: "transparent"
        }
      }
    },
    gray: {
      button: {
        fontWeight: 500,
        border: "none",
        background: "primary.50",
        _hover: {
          border: "none",
          backgroundColor: "primary.100",
          outlineColor: "transparent"
        },
        _focusVisible: {
          borderColor: "none",
          outlineColor: "primary.100",
          outlineWidth: 4,
          outlineStyle: "solid"
        },
        _expanded: {
          border: "none",
          backgroundColor: "primary.200",
          outlineColor: "transparent"
        },
        _active: {
          border: "none",
          backgroundColor: "primary.200",
          outlineColor: "transparent"
        }
      }
    },
    error: {
      button: {
        borderColor: "error.300",
        color: "error.500",
        _hover: {
          borderColor: "error.300",
          color: "error.700",
          outlineColor: "primary.50",
          outlineStyle: "solid",
          outlineWidth: "4px"
        },
        _focusVisible: {
          color: "error.700",
          borderColor: "error.500",
          outlineColor: "error.50",
          outlineStyle: "solid",
          outlineWidth: "4px"
        },
        _expanded: {
          borderColor: "error.500",
          outlineWidth: 4,
          outlineStyle: "solid",
          outlineColor: "error.50"
        },
        _active: {
          borderColor: "error.500",
          outlineColor: "error.50"
        }
      }
    }
  },
  sizes: {
    md: {
      button: {
        height: 10
      }
    },
    sm: {
      button: {
        height: 8
      }
    }
  },
  defaultProps: {
    size: "md"
  }
});
export {
  p as Select
};
//# sourceMappingURL=Select.es.js.map
